/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getProngStyles = ({ styleOverrides }) => () => {
  return {
    prong: _.extend({
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      top: 20,
      left: '50%',
      color: 'white',
      transform: 'translate(-50%)',
    }, styleOverrides.prongWindows),
    winStoreLogo: _.extend({
      position: 'absolute',
      top: 117,
      left: 83,
      zIndex: 2,
    }, styleOverrides.prongWindows),
    winStore: _.extend({
      position: 'absolute',
      top: 118,
      left: 93,
      fontWeight: 400,
      fontSize: 5,
      color: '#FFFFFF',
      zIndex: 2,
    }, styleOverrides.prongWindows),
    sponsored: _.extend({
      position: 'absolute',
      top: 169,
      left: 83,
      borderRadius: 2,
      fontWeight: 400,
      fontSize: 5,
      border: '0.25px solid #FFFFFF',
      padding: '0.5px 2px 0px 2px',
      color: '#FFFFFF',
      zIndex: 2,
    }, styleOverrides.prongWindows),
  };
};
